import { twMerge } from 'tailwind-merge'

import { stripMarkdown } from '@helpers/format'
import { getCourseVisualStyle } from '@helpers/courseUtils'
import Image from '@components/Image'

const CourseHeader = ({ className, courseId = '', name = '', description = '', imageUrl }) => {
  const formattedDescription = stripMarkdown(description)
  const { emoji, gradientFrom, gradientTo } = getCourseVisualStyle(courseId)

  return (
    <div className={twMerge('p-0 grow h-fit', className)}>
      <Choose>
        <When condition={imageUrl}>
          <Image
            className='object-cover w-full h-[200px] rounded-lg'
            src={imageUrl}
            placeholder={<div className='sm:rounded-lg rounded-none h-[200px] w-full bg-gray-200 animate-pulse border shadow-sm' />}
          />
        </When>

        <Otherwise>
          <div
            className='flex justify-center items-center rounded-lg h-[200px] w-full'
            style={{ background: `linear-gradient(135deg, ${gradientFrom}, ${gradientTo})` }}
          >
            <span className='text-6xl'>{emoji}</span>
          </div>
        </Otherwise>
      </Choose>

      <div className='pt-3 sm:px-0'>
        <h1 className='text-2xl font-semibold leading-none line-clamp-1 mb-3 mt-4'>{name}</h1>

        <If condition={formattedDescription}>
          <p className='mt-1 text-primary leading-none line-clamp-2 break-all'>
            {formattedDescription}
          </p>
        </If>
      </div>
    </div>
  )
}

export default CourseHeader
